import React from 'react';
import { CreditCardIcon, FileTextIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const items = [{
  icon: FileTextIcon,
  label: '100% Digital PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Crédito / Débito'
}];
export function TrustRow({
  className = ''
}: {
  className?: string;
}) {
  return <ul className={`flex flex-wrap items-center justify-center gap-x-6 gap-y-3 ${className}`} data-id="element-196" data-mp="1p1wg9vjfm7yu">
      {items.map(({
      icon: Icon,
      label
    }) => <li key={label} className="flex items-center gap-2 text-xs font-medium text-slate-400 sm:text-sm" data-id="element-197" data-mp="1yyj2oorep72z">
          <Icon className="h-4 w-4 text-ball-400" aria-hidden="true" data-id="element-198" data-mp="1tyn4j65e49vc" />
          {label}
        </li>)}
    </ul>;
}